import { Injectable } from '@angular/core';
import { DefaultSidebarComponent } from './../components/default-sidebar/default-sidebar.component';
import { ComponentProviderService } from '../../core/services/component-provider.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarProviderService extends ComponentProviderService {
  constructor() {
    super(DefaultSidebarComponent);
  }
}
